<template>
	<div class="infor_card">
		<text-item label="检测人" v-if="patientName">{{ patientName }}</text-item>
		<text-item label="检测项目" class="mt-32 mb-32" v-if="patientName"></text-item>

		<div class="infor_card_list">
			<div
				class="infor_card_list__item"
				v-for="(item, index) in list"
				:key="`infor_card_list__item_${ index }`"
			>
				<h3 class="infor_card_list__item__title">{{ item.title }}</h3>
				<div class="infor_card_list__item__content">{{ item.content }}</div>
				<div class="infor_card_list__item__detect" v-if="item.detectType||item.type===1&&item.itemList&&item.itemList.length>0">
					<div v-if="item.detectType">样本类型：{{ getDetectType(item.detectType) }}</div>
					<div v-if="item.type===1&&item.itemList&&item.itemList.length>0">检测项目：{{ item.itemList.map(v=>v.itemName).join('、') }}</div>
				</div>
				<div class="infor_card_list__item__desc">
					<div
						class="infor_card_list__item__desc__item"
						v-for="(val, idx) in item.desc"
						:key="`infor_card_list__item__desc__item_${ idx }`"
					>
						<div class="label" :style="val.labelStyle">{{ val.label }}</div>
						<!-- <div class="value" :style="val.valueStyle">{{ val.value }}</div> -->
					</div>
				</div>
			</div>
		</div>
		<text-item label="商品总额" class="mt-32" v-if="totalPrice">￥{{ totalPrice | priceFilter }}</text-item>
		<text-item label="样本类型" class="mt-32" v-if="sampleType">{{ sampleType }}</text-item>

		<div class="infor_card_total text-right" v-if="totalInfo">
			<span class="infor_card_total__inner pr-20">{{ totalInfo.totalNum }}</span>
			实付
			<span class="infor_card_total__inner price">￥{{ totalInfo.totalPrice | priceFilter }}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "InforCard",
	props: {
		list: {
			type: Array,
			default: () => []
		},
		totalPrice: {
			type: [String, Number],
			default: 0
		},
		sampleType: {
			type: String,
			default: ''
		},
		totalInfo: {
			type: Object,
			default: () => null
		},
		patientName: {
			type: String,
			default: ''
		}
	}, 
	data(){
		return {
			detectType:{}
		}
	},
	created(){
		this.getDetectTypeList()
	},
	methods: {
		getDetectTypeList() {
			this.$api.order.sampleList().then(res=>{
				if (!res.code) {
					let list = res.data
					let typeKey = {};
					list.map((v) => {
						typeKey[v.code] = v.name;
					});
					this.detectType = typeKey
				}
			})
		},
		getDetectType (val) {
			return ((val || '').split('&') || []).map(item => this.detectType[item]).join('、')
		},
	}
};
</script>

<style scoped lang="less">
	.infor_card {
		&_list {
			&__item {
				& + &{ margin-top: 24px; }
				border-radius: 14px;
				background-color: #F6F7F7;
				padding: 28px 24px;
				&__title {
					font-family: PingFangSC-Medium;
					font-size: 32px;
					font-weight: normal;
					line-height: 34px;
					color: #1A1A1A;
				}
				&__content {
					font-family: PingFangSC-Regular;
					font-size: 30px;
					line-height: 42px;
					color: #373C43;
					margin: 22px 0;
				}
				&__detect {
					font-family: PingFangSC-Regular;
					font-size: 26px;
					line-height: 42px;
					margin:0  0 22px;
					display: inline-block;
					border-radius: 10px;
					background-color: rgba(21, 197, 206, 0.1);
					padding: 21px ;
					>div {
						
						color: @primary;
						
					}
				}
				&__desc {
					&__item {
						.flex();
						&>div{ order: 1; }
						.label {
							font-family: PingFangSC-Medium;
							font-size: 30px;
							font-weight: normal;
							line-height: 34px;
							color: @danger;
						}
						.value {
							font-family: PingFangSC-Regular;
							font-size: 30px;
							font-weight: normal;
							line-height: 34px;
							letter-spacing: 2px;
							color: #1F2329;
						}
					}
				}
			}
		}
		&_total {
			margin-top: 32px;
			font-family: PingFangSC-Regular;
			font-size: 28px;
			font-weight: normal;
			line-height: 34px;
			color: #666;
			&__inner {
				line-height: 38px;
				color: #1F2329;
				&.price {
					font-family: PingFangSC-Medium;
					font-size: 32px;
				}
			}
		}
	}
</style>
